<template>
  <section class="home">
    <bg-div :bgArr="computedStyle.bgArr" :ow="750" :bgSize="'cover'" :bgPos="bgPos">
      <div @click="musicPlaying = true" v-show="!preloaded||!musicPlaying" class="muted"></div>
      <div @click="musicPlaying = false" v-show="musicPlaying" class="playing"></div>

      <mid-div
        style="z-index:1"
        :src="computedStyle.title.src"
        :pos="computedStyle.title.pos"
        :size="computedStyle.title.size"
        :isImg="true"
      />
      <mid-div
        style="z-index:1"
        :src="computedStyle.logo.src"
        :pos="computedStyle.logo.pos"
        :size="computedStyle.logo.size"
        :isImg="true"
      />

      <mid-div
        id="btn-draw"
        style="z-index:1;filter:grayscale(1);-webkit-filter:grayscale(1)"
        @mclick="check"
        :src="computedStyle.btnDraw.src"
        :pos="computedStyle.btnDraw.pos"
        :size="computedStyle.btnDraw.size"
        :isImg="true"
      />

      <mid-div
        id="btn-jump"
        @mclick="qrcodePopupShow(),fiboClick('btn-home-book', '预定联名款')"
        :src="computedStyle.btnJump.src"
        :pos="computedStyle.btnJump.pos"
        :size="computedStyle.btnJump.size"
        :isImg="true"
      />
      <mid-div
        style="z-index:1"
        @mclick="rulePopupShow(),fiboClick('btn-home-rule','活动规则')"
        :src="computedStyle.btnRule.src"
        :pos="computedStyle.btnRule.pos"
        :size="computedStyle.btnRule.size"
        :isImg="true"
      />

      <Popup
        class="first-popup"
        v-show="firstPopup"
        :show="firstPopupWrapper"
        @popup-hide="firstPopup = false"
      >
        <div class="popup-wrapper">
          <section v-show="(cardType !== 0 && received ===0) || !preloaded">
            <mid-div
              :src="computedStyle.popupBg.src"
              :pos="computedStyle.popupBg.pos"
              :size="computedStyle.popupBg.size"
              :isImg="true"
            />
            <mid-div
              @mclick="grab"
              :src="computedStyle.btnGrab.src"
              :pos="computedStyle.btnGrab.pos"
              :size="computedStyle.btnGrab.size"
              :isImg="true"
            />
            <mid-div
              v-show="!preloaded || cardType===1"
              :src="computedStyle.popuptitles[0].src"
              :pos="computedStyle.popuptitles[0].pos"
              :size="computedStyle.popuptitles[0].size"
              :isImg="true"
            />
            <mid-div
              v-show="!preloaded || cardType===2"
              :src="computedStyle.popuptitles[1].src"
              :pos="computedStyle.popuptitles[1].pos"
              :size="computedStyle.popuptitles[1].size"
              :isImg="true"
            />
            <mid-div
              v-show="!preloaded || cardType===3"
              :src="computedStyle.popuptitles[2].src"
              :pos="computedStyle.popuptitles[2].pos"
              :size="computedStyle.popuptitles[2].size"
              :isImg="true"
            />
            <mid-div
              @mclick="firstPopupHide"
              :src="computedStyle.btnClose[1].src"
              :pos="computedStyle.btnClose[1].pos"
              :size="computedStyle.btnClose[1].size"
              :isImg="true"
            />
          </section>

          <section v-show="(cardType !== 0 && received !==0)||!preloaded">
            <mid-div
              :src="computedStyle.grabed.src"
              :pos="computedStyle.grabed.pos"
              :size="computedStyle.grabed.size"
              :isImg="true"
            />
            <mid-div
              @mclick="checkCard"
              :src="computedStyle.btnCheck.src"
              :pos="computedStyle.btnCheck.pos"
              :size="computedStyle.btnCheck.size"
              :isImg="true"
            />
            <mid-div
              @mclick="firstPopupHide"
              :src="computedStyle.btnClose[0].src"
              :pos="computedStyle.btnClose[0].pos"
              :size="computedStyle.btnClose[0].size"
              :isImg="true"
            />
          </section>
        </div>
      </Popup>
      <Popup
        class="event-popup"
        v-show="eventPopup"
        :show="eventPopupWrapper"
        @popup-hide="eventPopup = false"
      >
        <div class="popup-wrapper">
          <mid-div
            v-show="eventState === 3"
            :src="computedStyle.beforeEvent.src"
            :pos="computedStyle.beforeEvent.pos"
            :size="computedStyle.beforeEvent.size"
            :isImg="true"
          />
          <mid-div
            v-show="eventState === 4"
            :src="computedStyle.afterEvent.src"
            :pos="computedStyle.afterEvent.pos"
            :size="computedStyle.afterEvent.size"
            :isImg="true"
          />
        </div>
      </Popup>
      <Popup
        class="rule-popup"
        v-show="rulePopup"
        :show="rulePopupWrapper"
        @popup-hide="rulePopup = false"
      >
        <div class="popup-wrapper">
          <mid-div
            :src="computedStyle.ruleWrapper.src"
            :pos="computedStyle.ruleWrapper.pos"
            :size="computedStyle.ruleWrapper.size"
            :isImg="true"
          />
          <mid-div
            @mclick="rulePopupHide"
            :src="computedStyle.btnRuleConfirm.src"
            :pos="computedStyle.btnRuleConfirm.pos"
            :size="computedStyle.btnRuleConfirm.size"
            :isImg="true"
          />
          <mid-div
            class="rule-shadow"
            :pos="computedStyle.ruleShadow.pos"
            :size="computedStyle.ruleShadow.size"
          />
          <mid-div
            id="rule-text-wrapper"
            :style="ruleTextStyle.wrapper"
            class="rule-text-wrapper"
            @mclick="rulePopupHide"
            :pos="computedStyle.ruleTextWrapper.pos"
            :size="computedStyle.ruleTextWrapper.size"
          >
            <p :style="ruleTextStyle.content">
              1、活动时间：
              <br />2019年9月4日-9月5日；
              <br />2、用户进入海澜之家H5活动页面参与活动，点击抽奖，可随机获得10元暴雪卫衣礼券、30元暴雪卫衣礼券或50元暴雪卫衣礼券1张；
              <br />3、奖品设置：
              <br />1) 10元暴雪卫衣礼券：不限量发放，每位用户限领1张；
              <br />2) 30元暴雪卫衣礼券：限量10万张，每位用户限领1张；
              <br />3) 50元暴雪卫衣礼券：限量1万张，每位用户限领1张；
              <br />4、每位用户仅可参与1次抽奖活动，奖品随机发放；
              <br />5、活动期间，在海澜之家微信官方商城参与暴雪预售活动，购买暴雪系列商品时，赠送指定款联名礼盒1个，限量4000个，先到先得；
              <br />6、券有效期：
              <br />2019年9月4日至9月5日；
              <br />7、所有奖券可在海澜之家微信官方商城购买暴雪系列商品时使用，不可在其他商城或线下门店使用；
              <br />8、所有奖券均为预售商品券，在此期间内（2019年9月4日至2019年9月5日）的订单将于9月6日起陆续发货；
              <br />9、奖券均以电子券的形式发放，用户可以在海澜之家公众号【个人中心】—【我的奖券】或微信【我】—【卡包】—【海澜之家】中查看领取情况；
              <br />10、每笔订单中仅限使用1张奖券，不可拆单使用，不可叠加使用；
              <br />11、所有奖券不可转赠，不兑现、不找零，不可与其他活动叠加使用；
              <br />12、使用奖券所购的商品如需退换货，在商品未穿着，吊牌完好，且不影响二次销售的情况下，需联系微信官方商城客服出示使用此券的订单，线上处理，可以调换货，如需退货（赠品需退回），则不退还已使用的奖券及抵用部分的金额；
              <br />13、使用奖券抵用部分的金额不予开具发票；
              <br />14、奖券严禁出售，一经发现并证实的，此券将予以作废处理；
              <br />15、由于帐户盗用等非常规原因或用户自身原因，造成此券异常最终不能使用的，与海澜之家无关；
              <br />16、对于任何通过不正当或非正常手段参与活动的用户，海澜之家有权取消其使用资格；
              <br />17、海澜之家在法律范围内保留对此活动规则及券使用细则的最终解释权。
              <br />
              <br />
              <br />
              <br />
            </p>
          </mid-div>
        </div>
      </Popup>
      <Popup
        class="busy-popup"
        v-show="busyPopup"
        :show="busyPopupWrapper"
        @popup-hide="busyPopup = false"
      >
        <div class="popup-wrapper">
          <mid-div
            v-show="busyState !== 503"
            :src="computedStyle.busy.src"
            :pos="computedStyle.busy.pos"
            :size="computedStyle.busy.size"
            :isImg="true"
          />
          <mid-div
            v-show="busyState === 503"
            :src="computedStyle.busyLimited.src"
            :pos="computedStyle.busyLimited.pos"
            :size="computedStyle.busyLimited.size"
            :isImg="true"
          />
        </div>
      </Popup>
      <Popup
        class="qrcode-popup"
        v-show="qrcodePopup"
        :show="qrcodePopupWrapper"
        @popup-hide="qrcodePopup = false"
      >
        <div class="qrcode-outer">
          <div class="qrcode-inner">
            <img class="qrcode-img" :src="qrcodeUrl" alt="qrcode" />
          </div>
        </div>
        <mid-div
          @mclick="qrcodePopupHide"
          :src="computedStyle.btnClose[2].src"
          :pos="computedStyle.btnClose[2].pos"
          :size="computedStyle.btnClose[2].size"
          :isImg="true"
        />
      </Popup>
      <Popup
        class="preload-popup"
        v-show="preloadPopup"
        :show="preloadPopupWrapper"
        @popup-hide="preloadPopup = false"
      >
        <div class="popup-wrapper preload-mask"></div>
      </Popup>
    </bg-div>
  </section>
</template>
<script>
import BgDiv from '../../components/wrapper/BackgroundWrapper';
import MidDiv from '../../components/wrapper/MidDiv';
import PopupWrapper from '../../components/wrapper/PopupWrapper';
import drawMixin from '../../mixins/homeAboutDraw';
import styleMixin from '../../mixins/homeAboutStyle';
import fiboClickMixin from '../../mixins/fiboClick';
import styleComputor from '../../mixins/styleComputor';
import Scrollbar from 'smooth-scrollbar';
import { jumpUrl } from '../../constants/common';

export default {
  components: {
    Popup: PopupWrapper,
    'bg-div': BgDiv,
    'mid-div': MidDiv
  },
  mixins: [drawMixin, styleMixin, styleComputor, fiboClickMixin],
  directives: {
    controllable(el, directive) {
      el.style.pointerEvents = directive.value ? '' : 'none';
    }
  },
  watch: {
    musicPlaying(playing) {
      let bgm = document.getElementById('bgm');
      if (!bgm) {
        console.debug('no bgm element');
        return;
      }
      if (playing) {
        bgm.play();
      } else {
        bgm.pause();
      }
    },
    eventHandled(val) {
      console.log(val / this.eventTotal);
      if (val >= this.eventTotal) {
        this.initCheck();
      }
    }
  },
  computed: {
    qrcodeUrl() {
      return require('../../assets/images/popup/qrcode.png');
    },
    bgPos() {
      return `center center`;
    },
    ruleTextStyle() {
      let content;
      let rate = innerWidth / 750;

      content = `
                font-size:${(23 * rate).toFixed(2)}px;
                color:black;
                line-height:${(30 * rate).toFixed(2)}px;
                `;
      return {
        content: content,
        wrapper: `box-sizing:border-box;
                  padding-right:${(20 * rate).toFixed(2)}px;`
      };
    }
  },
  data() {
    let data = {
      logined: false,
      preloaded: false,
      eventState: 1,

      // 进入需要监控的状态事件
      eventHandled: 0,
      eventTotal: 3,

      // 中奖情况
      cardType: 0,
      received: 0,
      musicPlaying: true,

      // 繁忙状态
      busyState: 0
    };

    // 弹窗控制字段
    let popups = ['first', 'event', 'rule', 'busy', 'preload', 'qrcode'];
    for (let popup of popups) {
      data[`${popup}Popup`] = false;
      data[`${popup}PopupWrapper`] = false;
    }

    return data;
  },
  created() {
    this.handleEnterEvents();
  },
  mounted() {
    this.preload();
    this.initScrollbar();
  },
  methods: {
    // 进入事件检测
    handleEnterEvents() {
      // 登录事件
      this.$bus.on('login-fail', () => {
        console.debug('handle login event.');
        this.eventHandled++;
        this.logined = false;
      });
      this.$bus.on('login-finish', result => {
        console.debug('handle login event.');
        this.cardType = result.cardType;
        this.received = result.received;
        this.eventHandled++;
        this.logined = true;
      });
      // 活动状态控制
      this.$bus.on('event-state', state => {
        this.eventHandled++;
        console.log('event state in home:', state);
        this.eventState = state; 
      });
      // 预载
      this.$on('preloaded', () => {
        this.eventHandled++;
      });
      // 限流控制
      this.$bus.on('limit-state', state => {
        console.log('limit state:', state);
        this.busyState = state || 1;
      });
    },
    preload() {
      this.firstPopupShow();
      this.eventPopupShow();
      this.rulePopupShow();
      this.preloadPopupShow();
      this.$nextTick(() => {
        this.firstPopupHide();
        this.eventPopupHide();
        this.rulePopupHide();
        this.preloadPopupHide();

        setTimeout(() => {
          this.preloaded = true;
        }, 100);
        setTimeout(() => {
          this.$emit('preloaded');
        }, 110);
      });
    },
    initScrollbar() {
      Scrollbar.init(document.querySelector('#rule-text-wrapper'), {
        alwaysShowTracks: true
      });
      this.$nextTick(() => {
        document.querySelector(
          '.scrollbar-track.scrollbar-track-y'
        ).style.background = '#815425';
        document.querySelector(
          '.scrollbar-track.scrollbar-track-y'
        ).style.width = `${((6 * innerWidth) / 750).toFixed(2)}px`;
        document.querySelector('.scrollbar-thumb-y').style.background =
          '#dfbc39';
        document.querySelector('.scrollbar-thumb-y').style.width = `${(
          (6 * innerWidth) /
          750
        ).toFixed(2)}px`;
      });
    },
    // 检测进入状况（活动状态/中奖状态）
    initCheck() {
      // 限流
      if (this.busyState !== 0) {
        this.busyPopupShow();
        return;
      }

      // 活动时间
      if (this.eventState !== 1) {
        this.eventPopupShow();
        return;
      }

      // 登录失败
      if (!this.logined || this.eventState === -1) {
        this.busyPopupShow();
        return;
      }

      let { style: btnStyle } = document.getElementById('btn-draw');
      // 中奖情况
      if (this.received !== 0 && this.cardType !== 0) {
        btnStyle.webkitFilter = btnStyle.filter = '';
        this.firstPopupShow();
        return;
      } else if (this.cardType !== 0) {
        btnStyle.webkitFilter = btnStyle.filter = '';
        this.firstPopupShow();
        return;
      } else {
        btnStyle.webkitFilter = btnStyle.filter = '';
      }
    },
    // 显示/隐藏
    firstPopupShow() {
      this.firstPopup = this.firstPopupWrapper = true;
    },
    eventPopupShow() {
      this.eventPopup = this.eventPopupWrapper = true;
    },
    rulePopupShow() {
      this.rulePopup = this.rulePopupWrapper = true;
    },
    busyPopupShow() {
      this.busyPopup = this.busyPopupWrapper = true;
    },
    qrcodePopupShow() {
      this.qrcodePopup = this.qrcodePopupWrapper = true;
    },
    preloadPopupShow() {
      this.preloadPopup = this.preloadPopupWrapper = true;
    },
    firstPopupHide() {
      this.firstPopupWrapper = false;
    },
    eventPopupHide() {
      this.eventPopupWrapper = false;
    },
    rulePopupHide() {
      this.rulePopupWrapper = false;
    },
    busyPopupHide() {
      this.busyPopupWrapper = false;
    },
    qrcodePopupHide() {
      this.qrcodePopupWrapper = false;
    },
    preloadPopupHide() {
      this.preloadPopupWrapper = false;
    }
  }
};
</script>
<style lang='scss' scoped>
.home {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  background: black;
}
.middle-btn {
  position: absolute;
  @include flex-both-middle;
  width: 100%;
  bottom: 20vh;
  animation: showBtn 0.1s ease-in;
}
@keyframes showBtn {
  from {
    transform: scale(0.5);
  }
  to {
    transform: scale(1);
  }
}
.popup-wrapper {
  @include abs-full-page;
  @include flex-both-middle;
}
@font-face {
  font-family: 'PF';
  src: url('../../assets/fonts/PingFangSC-Regular.otf') format('opentype');
}
.rule-text-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  & p {
    text-align: justify;
    font-family: 'PF';
    & b {
      font-family: 'MICROSOFT YAHEI';
    }
  }
}
.rule-shadow {
  z-index: 1;
  background: linear-gradient(
    rgba(224, 200, 156, 0.4),
    rgba(224, 200, 156, 0.95)
  );
  border: 0;
  filter: blur(2px);
  -webkit-filter: blur(2px);
  box-shadow: 0 10px 15px rgba(224, 200, 156, 0.8);
}
.preload-mask {
  z-index: 10;
  background: black;
}
.arrow {
  z-index: 1;
  pointer-events: none;
}

.muted {
  background-image: url('../../assets/images/music/muted.png');
}
.playing {
  background-image: url('../../assets/images/music/playing.png');
}

.muted,
.playing {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @include set_property_by_size('width', 52);
  @include set_property_by_size('height', 45);
  position: fixed;
  @include set_property_by_size('right', 45);
  @include set_property_by_size('top', 45);
}
.qrcode-img {
  position: absolute;
  @include set_property_by_size('width', 514);
  @include set_property_by_size('height', 526);
  @include set_property_by_size('left', -254);
  @include set_property_by_size('top', -362);
}
.qrcode-outer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.qrcode-inner {
  position: relative;
  width: 0;
  height: 0;
}
</style>

